import UnifiedCalendar from "@/components/UnifiedCalendar";
import Seo from "@/components/Seo";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight } from "lucide-react";

export default function PublicCalendar() {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10" data-testid="public-calendar-page">
      <Seo title="Calendar — What's Happening" description="See upcoming wellness sessions, classes, events and gatherings at Enhancing Your World centers in Newport and Verona, KY and online." />
      <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#D98E73] mb-2 flex items-center gap-2"><CalendarDays size={14} /> What's Happening</p>
      <div className="flex flex-wrap items-end justify-between gap-3 mb-8">
        <div>
          <h1 className="font-serif text-3xl sm:text-4xl text-[#1A242B] mb-2">Community calendar</h1>
          <p className="text-[#4A5D6B]">Events, classes, and live broadcasts open for registration.</p>
        </div>
        <Link to="/events" data-testid="public-cal-events-link" className="eyw-btn-outline !py-2 text-sm">Browse event details <ArrowRight size={14} /></Link>
      </div>
      <UnifiedCalendar scope="public" />
    </div>
  );
}
